import React from 'react';
import { CRISIS_RESOURCES } from '../services/safety/crisisDetection.js';

const PAPER = '#F2EBDC';
const INK = '#1A1A1A';
const MUTED = '#5A5A5A';
const ACCENT = '#B85A3E';

export default function CrisisResourceCard() {
  return (
    <div
      role="region"
      aria-label="Crisis support resources"
      style={{
        margin: '16px 0',
        padding: '20px',
        background: PAPER,
        border: `2px solid ${ACCENT}`,
        borderRadius: '12px',
        fontFamily: 'Georgia, serif',
        color: INK,
      }}
    >
      <h3 style={{ margin: '0 0 12px', fontSize: '17px', fontWeight: 600, color: INK }}>
        If you need someone to talk to right now
      </h3>
      <ul style={{ margin: 0, padding: 0, listStyle: 'none' }}>
        {CRISIS_RESOURCES.map((r) => (
          <li key={r.display} style={{ margin: '8px 0' }}>
            <a
              href={r.href}
              style={{ color: ACCENT, fontWeight: 600, textDecoration: 'none' }}
            >
              {r.display}
            </a>
            <span style={{ color: MUTED }}> — {r.desc}</span>
          </li>
        ))}
      </ul>
      <p style={{ margin: '12px 0 0', fontSize: '14px', color: MUTED, fontStyle: 'italic' }}>
        These resources are available 24/7. You don&apos;t have to face this alone.
      </p>
    </div>
  );
}
